import { render, staticRenderFns } from "./NotificationAddDoc.vue?vue&type=template&id=b311e6ac"
import script from "./NotificationAddDoc.vue?vue&type=script&lang=js"
export * from "./NotificationAddDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationAddDoc.vue?vue&type=style&index=0&id=b311e6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports